import { render, staticRenderFns } from "./transactionRecords.vue?vue&type=template&id=4730a314&scoped=true&"
import script from "./transactionRecords.vue?vue&type=script&lang=js&"
export * from "./transactionRecords.vue?vue&type=script&lang=js&"
import style0 from "./transactionRecords.vue?vue&type=style&index=0&id=4730a314&lang=less&scoped=true&"
import style1 from "./transactionRecords.vue?vue&type=style&index=1&id=4730a314&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730a314",
  null
  
)

export default component.exports